namespace GeniuzPOS.QRreport {
    export interface QDayDataForm {
        Day: Serenity.IntegerEditor;
        DayName: Serenity.StringEditor;
        DayNameEn: Serenity.StringEditor;
    }

    export class QDayDataForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QDayData';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QDayDataForm.init)  {
                QDayDataForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(QDayDataForm, [
                    'Day', w0,
                    'DayName', w1,
                    'DayNameEn', w1
                ]);
            }
        }
    }
}
